import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=21561f85&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"
import style0 from "./Create.vue?vue&type=style&index=0&id=21561f85&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/cartaz-pratico/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports